import React from 'react';
import classNames from 'classnames';
import propTypes from 'prop-types';
import { getCropBasedMessage } from 'util/locale';

// components
import BaseTrigger from 'triggers/BaseTrigger';
import HtmlText from 'html-text/HtmlText';
import { Icon } from '@tcc/crate';
import { useSelector } from 'react-redux';
import { getActiveCropId } from 'current/currentSelectors';

const baseString = 'vra-add-seed-product-input-trigger';
const classString = classNames({
  [`${baseString}`]: true
});
const AddSeedProductInputTrigger = ({
  isVisible,
  onClick,
  showHelpText = false,
  showPlus = false
}) => {
  const cropId = useSelector(getActiveCropId);
  return isVisible ? (
    <section className={classString}>
      {showPlus && <Icon className={`${baseString}__add-icon`} glyph={Icon.set.ADD} />}
      <BaseTrigger
        className={`${baseString}__trigger`}
        content={getCropBasedMessage({ key:'button-text__dual-seed', cropId })}
        dataTestId={baseString}
        handler={onClick}
      />
      {
        showHelpText && (
          <section>
            <small>
              <HtmlText messageKey={`help-text__dual-seed.${cropId}`} />
            </small>
          </section>
        )
      }
    </section>
  ) : null;
};
AddSeedProductInputTrigger.propTypes = {
  isVisible: propTypes.bool.isRequired,
  onClick: propTypes.func.isRequired,
  showHelpText: propTypes.bool,
  showPlus: propTypes.bool,
  showTooltip: propTypes.bool
};
export default AddSeedProductInputTrigger;
